import { fromJS } from 'immutable';


const initialState = fromJS({

});

export function copyPaste(state = initialState, { type, payload }) {
  switch (type) {
    case 'COPY_GENERIC_ITEM':
      return state.merge(fromJS(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/copy-paste/copy-paste-reducer.js